import { useEffect, useState } from "react";
import api, { formatApiError } from "../../lib/api";
import PageHeader from "../../components/PageHeader";
import { Switch } from "../../components/ui/switch";
import { Globe, Loader2, ExternalLink } from "lucide-react";
import { toast } from "sonner";

export default function SitoWeb() {
  const [enabled, setEnabled] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/admin/sito").then(({ data }) => setEnabled(data.enabled)).catch((e) => toast.error(formatApiError(e.response?.data?.detail))); }, []);

  const toggle = async (v) => {
    setBusy(true);
    try { const { data } = await api.put("/admin/sito", { enabled: v }); setEnabled(data.enabled); toast.success(v ? "Sito attivato" : "Sito disattivato"); }
    catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
    finally { setBusy(false); }
  };

  if (enabled === null) return <div className="py-10 flex justify-center"><Loader2 className="h-6 w-6 animate-spin text-amber-500" /></div>;
  return (
    <div data-testid="admin-sito-web">
      <PageHeader title="Sito Web" subtitle="Pagina di presentazione pubblica mostrata alla radice del dominio (/)." icon={Globe} />
      <div className="max-w-2xl rounded-xl border border-slate-800 bg-[#121824] p-6 flex items-center justify-between gap-4">
        <div>
          <div className="text-sm font-semibold text-slate-100">{enabled ? "Disattiva sito" : "Attiva sito"}</div>
          <div className="text-xs text-slate-400" data-testid="sito-web-status">
            {enabled ? "Attivo: chi apre / vede il sito di presentazione." : "Disattivato: chi apre / viene portato al login del gestionale."}
          </div>
          <a href="/" target="_blank" rel="noopener noreferrer" className="mt-2 inline-flex items-center gap-1 text-xs text-sky-500 hover:underline" data-testid="sito-web-open">
            <ExternalLink className="h-3 w-3" /> Apri la radice del sito
          </a>
        </div>
        <Switch checked={enabled} disabled={busy} onCheckedChange={toggle} data-testid="sito-web-switch" />
      </div>
    </div>
  );
}
